import _isEmpty from "lodash/isEmpty";
import { useContext } from 'react';
import classnames from 'classnames';
import { Card } from "../Card/Card";
import { Coin } from "../../Coin/Coin";
import { LayoutContext } from "../../../context/layout.context";
import { Text } from "../../Text/Text/Text";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import Utility from "../../Utility/Utility";
import styles from "./LargeCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LargeCard = function LargeCard(_ref) {
  var title = _ref.title,
    image = _ref.image,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    _ref$personalPoints = _ref.personalPoints,
    personalPoints = _ref$personalPoints === void 0 ? {} : _ref$personalPoints,
    _ref$cardActionAttrib = _ref.cardActionAttributes,
    cardActionAttributes = _ref$cardActionAttrib === void 0 ? {} : _ref$cardActionAttrib;
  var layout = useContext(LayoutContext);
  var renderTop = function renderTop() {
    var oneX = image ? Utility.getOptimizedCloudinaryUrl(image, {
      width: 805
    }) : '';
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.largeCardImage, {
        [styles[layout]]: layout === 'sidebarBody',
        [styles.largeCardFoodImage]: !_isEmpty(personalPoints)
      }),
      "data-e2e-name": "large_card_image",
      children: /*#__PURE__*/_jsx("div", {
        className: styles.largeCardImageBackground,
        children: oneX && /*#__PURE__*/_jsx("img", {
          src: oneX,
          alt: "",
          className: styles.largeCardImageContent,
          loading: "lazy"
        })
      })
    });
  };
  var renderPersonalPoints = function renderPersonalPoints(value, secondValue, pointLabel) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.largeCardCoinContainer,
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Coin, {
          size: "small",
          value: value,
          secondValue: secondValue,
          label: pointLabel
        })
      })
    });
  };
  var renderBottom = function renderBottom() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.largeCardText,
      "data-e2e-name": "large_card_text",
      children: [/*#__PURE__*/_jsx(HeadingText, {
        align: "left",
        ariaLevel: 2,
        typog: "headline4",
        children: title
      }), personalPoints && typeof personalPoints.value === 'number' && renderPersonalPoints(personalPoints.value, personalPoints.secondValue, personalPoints.label), /*#__PURE__*/_jsx("div", {
        className: styles.largeCardSubtitle,
        "data-e2e-name": "large_card_subtitle",
        children: subtitle !== '' && /*#__PURE__*/_jsx(Text, {
          typog: "bodycopy",
          children: subtitle
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx(Card, {
    bottom: renderBottom(),
    dropShadow: true,
    link: link,
    newWindow: newWindow,
    rowLayout: true,
    top: renderTop(),
    cardActionAttributes: cardActionAttributes
  });
};